export const FEE = Object.freeze([500, 990, 1450, 2100, 2900]);
